export const TOP_LEVEL_GROSIR_SLUGS = new Set([
  'kaos-kaki',
  'handuk',
  'keset-karpet',
  'piyama-oneset',
  'cd-underwear',
  'perlengkapan-medis',
])

export function getGrosirLandingPath(slug: string) {
  if (slug === 'perlengkapan-medis') return '/perlengkapan-medis'
  return TOP_LEVEL_GROSIR_SLUGS.has(slug)
    ? `/grosir-${slug}`
    : `/lp/grosir-${slug}`
}

const INDEXABLE_CATEGORY_NAVIGATION_SLUGS = new Set([
  'kaos-kaki',
  'cd-underwear',
  'piyama-oneset',
])

export function getCategoryNavigationPath(slug: string) {
  return INDEXABLE_CATEGORY_NAVIGATION_SLUGS.has(slug)
    ? `/kategori/${slug}`
    : getGrosirLandingPath(slug)
}
